import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import CreateBrandForm from './CreateBrandForm';

const CreateBrandPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Button
        size="sm"
        color="info"
        onClick={toggle}
        className="d-flex align-items-center gap-1"
      >
        <i className="bx bx-plus"></i> Create Brand
      </Button>

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          Create New Brand
        </ModalHeader>
        <ModalBody>
          <CreateBrandForm handleClose={toggle} isFromPopup={true} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateBrandPopup;
